export default "__VITE_ASSET__Dnj5tNWl__"